import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import SaudeService from '../../../../../../services/saude-auth';



const FormBusca = (props) => {
    const [nomeCompleto, setNomeCompleto] = useState("");
    const [situacao, setSituacao] = useState("");
    const [inscritoComo, setInscritoComo] = useState("");
    const [eixoDebate, setEixoDebate] = useState("")

    const busca = async (query) => {
        if (query == "") {
            props.setVazio(true)
        } else {
            var response = await SaudeService.buscar(query)
            if (response.data.length >= 1) {
                props.setInscricoes(response.data)
                props.setVazio(false)
            } else {
                props.setVazio(true)
            }
        }
    }

    const defineEixo = async (e) => {
        switch (e) {
            case "Eixo I":
                setEixoDebate("Eixo I - Fortalecimento da Atenção Primária e Qualificação da Atenção Especializada")
                break;
            case "Eixo II":
                setEixoDebate("Eixo II - Financiamento do SUS, Monitoramento e Avaliação dos Instrumentos de Gestão")
                break;
            case "Eixo III":
                setEixoDebate("Eixo III - Participação Popular e o Papel do Controle Social")
            default:
                setEixoDebate("Deu erro!")
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (nomeCompleto) prepQuery = prepQuery + `&nomeCompleto=${encodeURI(nomeCompleto)}`;
        if (situacao !== "false" && situacao !== "") prepQuery = prepQuery + `&situacao=${encodeURI(situacao)}`;
        if (eixoDebate !== "false" && eixoDebate !== "") prepQuery = prepQuery + `&eixoDebate=${encodeURI(eixoDebate)}`;
        if (inscritoComo !== "false" && inscritoComo !== "") prepQuery = prepQuery + `&inscritoComo=${encodeURI(inscritoComo)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={3}>
                        <Col>
                            <Form.Group className="mb-3" controlId="situacao">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="situacao"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Pendente">Pendente</option>
                                        <option value="Inscrito">Inscrito</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="inscritoComo">
                                <FloatingLabel
                                    label="Inscrito como:"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="inscritoComo"
                                        name="inscritoComo"
                                        onChange={e => setInscritoComo(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Delegado">Delegado</option>
                                        <option value="Participante">Participante</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="eixoDebate">
                                <FloatingLabel
                                    label="Eixo escolhido"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="eixoDebate"
                                        name="eixoDebate"
                                        onChange={e => defineEixo(e.target.value)}
                                    >
                                        <option value="false">TODOS</option>
                                        <option value="Eixo I">Eixo I</option>
                                        <option value="Eixo II">Eixo II</option>
                                        <option value="Eixo III">Eixo III</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Nome">
                                <FloatingLabel
                                    label="Nome Completo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nomeCompleto"
                                        value={nomeCompleto}
                                        onChange={e => setNomeCompleto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>


                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca